import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PermissionEnum } from '@ui/src';
import { useLazyGetEmployeesDictionariesQuery } from '@administration/store/dictionaries/service';
import { useAppSelector } from '@store';
import { useLazyGetAccountsTransactionTypesQuery } from '../../store/dictionaries/services';
import StatementsList from './list';

import cn from './styles.module.css';

const Statements = (): React.JSX.Element => {
  const { transactionTypes } = useAppSelector(
    (state) => state.accountsDictionaries,
  );
  const { users } = useAppSelector((state) => state.administrationDictionaries);
  const { activePermissions } = useAppSelector((state) => state.root);

  const [getAccountsTransactionTypes] =
    useLazyGetAccountsTransactionTypesQuery();
  const [getEmployeeDictionaries] = useLazyGetEmployeesDictionariesQuery();

  useEffect(() => {
    if (
      !users &&
      activePermissions &&
      activePermissions?.includes(PermissionEnum.USERS_LIST)
    ) {
      getEmployeeDictionaries();
    }
  }, [users, activePermissions]);

  useEffect(() => {
    if (!transactionTypes) {
      getAccountsTransactionTypes();
    }
  }, [transactionTypes]);

  useEffect(() => {
    let title = 'Statement of accounts';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <div className={cn.statements}>
      <StatementsList />
      <Outlet />
    </div>
  );
};

export default Statements;
